/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Pass_MonthlyInputs */

const en_features_pass_monthly = /** @type {(inputs: Features_Pass_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription`)
};

const pl_features_pass_monthly = /** @type {(inputs: Features_Pass_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonament`)
};

/**
* | output |
* | --- |
* | "Subscription" |
*
* @param {Features_Pass_MonthlyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_pass_monthly = /** @type {((inputs?: Features_Pass_MonthlyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Pass_MonthlyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_pass_monthly(inputs)
	return en_features_pass_monthly(inputs)
});